import http from '~/utils/http'

export function getOrder(page: number, size: number) {
  return http.get('/admin/order', {
    params: {
      page,
      size,
    },
  })
}
